var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStayProductive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 59.758 59.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9-productivity",
    "data-name": "9-productivity",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24977",
    "data-name": "Path 24977",
    d: "M58.456,21.242a.915.915,0,0,0-.882-.2L42.93,25.364a.918.918,0,0,0-.389,1.529l2.451,2.451L32.13,42.206l-7.77-7.771a4.6,4.6,0,0,0-6.515.025L.245,53.424a.918.918,0,1,0,1.346,1.249L19.166,35.734a2.758,2.758,0,0,1,3.9,0l8.419,8.42a.945.945,0,0,0,1.3,0l14.16-14.16a.918.918,0,0,0,0-1.3l-2.008-2.008,11.694-3.455-2.6,12.553-1.9-1.9a.918.918,0,0,0-1.3,0L34.078,50.644a2.758,2.758,0,0,1-3.9,0l-8.419-8.42a.918.918,0,0,0-1.338.043L5.737,58.949a.918.918,0,1,0,1.378,1.213L21.157,44.215l7.728,7.729a4.6,4.6,0,0,0,6.491,0L51.483,35.835l2.451,2.451a.918.918,0,0,0,1.548-.463L58.733,22.1a.92.92,0,0,0-.277-.861Z",
    transform: "translate(0 -1.722)",
    fill: "#ff0185",
    stroke: "#ff0185",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24978",
    "data-name": "Path 24978",
    d: "M16.918,56a.918.918,0,0,0-.918.918v5.508a.918.918,0,1,0,1.836,0V56.918A.918.918,0,0,0,16.918,56Z",
    transform: "translate(-1.312 -4.592)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24979",
    "data-name": "Path 24979",
    d: "M4.918,47.606a.918.918,0,0,0,.918-.918V33.836h9.18v.918a.918.918,0,1,0,1.836,0V32.918A.918.918,0,0,0,15.934,32H4.918A.918.918,0,0,0,4,32.918v13.77A.918.918,0,0,0,4.918,47.606Z",
    transform: "translate(-0.328 -2.624)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24980",
    "data-name": "Path 24980",
    d: "M46.918,48a.918.918,0,0,0-.918.918V61.77a.918.918,0,0,0,1.836,0V48.918A.918.918,0,0,0,46.918,48Z",
    transform: "translate(-3.772 -3.936)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24981",
    "data-name": "Path 24981",
    d: "M46.918,22.032a.918.918,0,0,0,.918-.918V1.836h9.18V17.442a.918.918,0,0,0,1.836,0V.918A.918.918,0,0,0,57.934,0H46.918A.918.918,0,0,0,46,.918v20.2A.918.918,0,0,0,46.918,22.032Z",
    transform: "translate(-3.772)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24982",
    "data-name": "Path 24982",
    d: "M58.918,42a.918.918,0,0,0-.918.918v18.36a.918.918,0,0,0,1.836,0V42.918A.918.918,0,0,0,58.918,42Z",
    transform: "translate(-4.756 -3.444)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24983",
    "data-name": "Path 24983",
    d: "M37.918,57a.918.918,0,0,0-.918.918v4.59a.918.918,0,0,0,1.836,0v-4.59A.918.918,0,0,0,37.918,57Z",
    transform: "translate(-3.034 -4.674)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24984",
    "data-name": "Path 24984",
    d: "M25.918,31.934a.918.918,0,0,0,.918-.918v-9.18h9.18V36.524a.918.918,0,0,0,1.836,0V20.918A.918.918,0,0,0,36.934,20H25.918a.918.918,0,0,0-.918.918v10.1A.918.918,0,0,0,25.918,31.934Z",
    transform: "translate(-2.05 -1.64)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24985",
    "data-name": "Path 24985",
    d: "M25.918,51a.918.918,0,0,0-.918.918v10.1a.918.918,0,1,0,1.836,0v-10.1A.918.918,0,0,0,25.918,51Z",
    transform: "translate(-2.05 -4.182)",
    fill: "#96006b",
    stroke: "#96006b",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStayProductive);
export default __webpack_public_path__ + "static/media/StayProductive.127ba8b6e498fae58f454a784b7130d6.svg";
export { ForwardRef as ReactComponent };